import { initializeApp, getApps, getApp } from "firebase/app";

// Your web app's Firebase configuration using environment variables
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

/**
 * Returns the shared Firebase app, creating it on first use.
 *
 * Only the app itself lives here. Each service (Firestore, Auth, Storage) is
 * created lazily by the module that needs it, so public pages never pay for
 * Auth or Storage (the Auth SDK opens an iframe to firebaseapp.com and loads
 * Google's gapi script as soon as it is initialised).
 */
export const getFirebaseApp = () =>
  getApps().length ? getApp() : initializeApp(firebaseConfig);
